import type { FunctionComponent } from 'react';

import { Spinner } from '@trello/nachos/spinner';

import styles from './CardBackLoading.less';

export const CardBackLoading: FunctionComponent = () => (
  <div className={`${styles.cardDetailLoading}`}>
    <Spinner centered={true} />
  </div>
);
